import React from "react";
import { Link } from 'react-router-dom';
import YoutubeEmbed from "../components/YoutubeEmbed";

const SuperSandPage = () => {
    return (
        <div>
            <div className="center">
                <div className="fiery">
                    <div className="littlenefarious">
                        SuperSand
                    </div>
                </div>
                <div className="smallheading">
                    <Link to="https://github.com/Schmitt-Very-Cool/SuperSand">GitHub</Link>
                    <Link to="https://the-nefarious-machine.itch.io/supersand" style={{ marginLeft: "10px" }}>Itch.io</Link>
                </div>
                <br/>
                <YoutubeEmbed embedId="GHPuJmhAPXE"/>
                <br/>
                <div className="subheading">Description</div>
                SuperSand is a falling sand game that utilizes cellular automata to simulate 2d physics that I'm making
                 in my free time. I wrote the code in C++ and used SFML for the GUI. The game is still in development, 
                 but I've made great progress. There are over 30 types of particles in the simulation. Each particle 
                 has persistent data such as color, temperature, and velocity. I've recently added thermal dynamics to 
                the simulation, and each particle type has its own thermal conductivity and specific heat capacity that
                 contribute to how heat flows through it. Next, I hope to add chemical reactions to the simulation.
                <br/>
                <br/>
                <div className="subheading">Gallery</div>
                <div className="gallery">
                    <img className="gallery-item" src="assets/supersand/bricks.jpg"/>
                    <img className="gallery-item" src="assets/supersand/menu.jpg"/>
                    <img className="gallery-item" src="assets/supersand/layers.jpg"/>
                </div>
            </div>
        </div>
    );
}

export default SuperSandPage;